// extracted by mini-css-extract-plugin
export default {"root":"SuppliersView_root__m5Jbs","panel":"SuppliersView_panel__Obsux","content":"SuppliersView_content__O5NuS"};